import { ResultOf } from "gql.tada";
import { HeroById } from "@queries/entries/HeroById";
import { FullImageWithCopyHero } from "./FullImageWithCopyHero.tsx";
import { VideoWIthCopyAndCtaHero } from "./VideoWIthCopyAndCtaHero.tsx";
import { SplitImageHero } from "./SplitImageHero.tsx";
import { VideoWithCopyHero } from "./VideoWithCopyHero.tsx";
import { normalizeVariant } from "@utils/textUtils";

type HeroEntry = ResultOf<typeof HeroById>;

export const Hero = ({ entry }: { entry: HeroEntry }) => {
  const variant = normalizeVariant(entry.hero?.variant);

  if (variant === "video-copy-cta") {
    return <VideoWIthCopyAndCtaHero entry={entry} />;
  }

  if (variant === "split-image-copy") {
    return <SplitImageHero entry={entry} />;
  }

  if (variant === "video-copy") {
    return <VideoWithCopyHero entry={entry} />;
  }

  // "full-image-copy", "media-background", and unrecognized → FullImageWithCopyHero
  return <FullImageWithCopyHero entry={entry} />;
};
